import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';
import { SessionPhase } from './scenarioinfo';
import { useTranslation } from 'react-i18next';

// Enhanced loading states
enum LoadingState {
  INITIAL,
  CONNECTING,
  LOADING_SCENARIO,
  READY,
  ERROR,
}

// ControlPanel Component
export const ControlPanel = ({
  phase,
  onEnd,
  onSkipIntro,
  isAISpeaking,
  isIntroCompleted = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white border-t border-gray-200 p-4">
      <div className="max-w-3xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Button
            variant="outline"
            size="sm"
            onClick={onSkipIntro}
            disabled={isIntroCompleted || phase !== SessionPhase.INTRO}
          >
            {t('coach.control_panel.skip_intro')}
          </Button>

          <Button
            variant="destructive"
            size="sm"
            onClick={onEnd}
            disabled={
              phase === SessionPhase.PRE_START || phase === SessionPhase.INTRO
            }
          >
            {t('coach.control_panel.end_session')}
          </Button>
        </div>

        <div className="flex items-center space-x-2">
          <span
            className={cn(
              'inline-flex h-3 w-3 rounded-full',
              isAISpeaking ? 'bg-green-500' : 'bg-gray-300',
            )}
          >
            <span
              className={cn(
                'animate-ping inline-flex h-full w-full rounded-full',
                isAISpeaking ? 'bg-green-400 opacity-75' : 'opacity-0',
              )}
            />
          </span>
          <span className="text-sm text-gray-600">
            {isAISpeaking
              ? t('coach.control_panel.ai_status.speaking')
              : t('coach.control_panel.ai_status.listening')}
          </span>
        </div>
      </div>
    </div>
  );
};
